<script>
    import { getCurrentDate } from './utils.js';
    let search = '';
    
    const handleSubmit = event => {
        event.preventDefault();

        const params = new URLSearchParams({
            keyword: search,
            date: getCurrentDate(),
        });

        window.location.href = `${window.location.pathname}?${params}`;
    };
</script>

<div class="border-zinc-700 border-2 rounded-r-xl mb-2 ml-2">
    <h1 class="text-blue-400 font-bold text-2xl p-2">NETWORK GRAPH</h1>
</div>
<div class="border-zinc-700 border-2 rounded-r-xl mb-2 ml-2">
    <form class="" on:submit={handleSubmit}>
        <input 
            bind:value={search}
            class="w-full px-3 py-2 rounded shadow text-zinc-400 bg-zinc-700 border-2 border-zinc-700 focus:outline-none focus:border-zinc-400"
            type="search" 
            placeholder="Search..." 
            name="search"
        />
        <input type="submit" style="display: none;">
    </form>
</div>
